import type { ToastPayload } from './toast.types';

type ToastHandler = (payload: ToastPayload) => void;

let toastHandler: ToastHandler | null = null;

export const registerToastHandler = (handler: ToastHandler): (() => void) => {
  toastHandler = handler;

  return () => {
    if (toastHandler === handler) {
      toastHandler = null;
    }
  };
};

export const showToast = (payload: ToastPayload): void => {
  toastHandler?.(payload);
};
